import { render, staticRenderFns } from "./leaderboard-table.vue?vue&type=template&id=4e582aba&scoped=true&"
import script from "./leaderboard-table.vue?vue&type=script&lang=js&"
export * from "./leaderboard-table.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard-table.vue?vue&type=style&index=0&id=4e582aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e582aba",
  null
  
)

export default component.exports